import { render } from "./StudentStudyDataApplyModal.vue?vue&type=template&id=9e0c7482&scoped=true"
import script from "./StudentStudyDataApplyModal.vue?vue&type=script&lang=js"
export * from "./StudentStudyDataApplyModal.vue?vue&type=script&lang=js"

import "./StudentStudyDataApplyModal.vue?vue&type=style&index=0&id=9e0c7482&scoped=true&lang=css"
import "./StudentStudyDataApplyModal.vue?vue&type=style&index=1&id=9e0c7482&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\project\\sparta\\sparta-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e0c7482"]])

export default __exports__